import script from "./FormReservasi2.vue?vue&type=script&setup=true&lang=js"
export * from "./FormReservasi2.vue?vue&type=script&setup=true&lang=js"

import "./FormReservasi2.vue?vue&type=style&index=0&id=3126829d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3126829d"]])

export default __exports__